import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import "../../styles/LangSelectGlobals.css";
import "../../styles/LangSelectStyle.css";
import "../../styles/LangSelectStyleGuide.css";

export default function LangSelect() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="select-language">
    <main className="select-language">
      <div className="app-container">
        <section className="app-content">
          <div className="app-logo">
            <img className="limot-logo" src="/images/logo_limot.png" alt="Limot logo" />
          </div>
          <div className="app-description">
            <p lang="ja">このアプリはガイドアプリです。<br />ガイドに利用する言語を選んでください。</p>
            <p lang="en">This app is Guide App. Select your language.</p>
            <p lang="zh">此应用程序为导览应用程序。请选择您的语言。</p>
            <p lang="ko">이 앱은 가이드 앱입니다. 언어를 선택하세요.</p>
          </div>
          <nav className="language-selection">
            <button onClick={() => {
              i18n.changeLanguage('ja');
              navigate('/okuno-shima/renttutorial');
            }} className="language-button language-button-large" lang="ja">
              <span>日本語</span>
              <div className="arrow-circle">
                <img className="arrow-icon" src="/images/lang_select/ChevronRight.svg" alt="Select Japanese" />
              </div>
            </button>
            <button onClick={() => {
              i18n.changeLanguage('en');
              navigate('/okuno-shima/renttutorial');
            }} className="language-button language-button-large" lang="en">
              <span>English</span>
              <div className="arrow-circle">
                <img className="arrow-icon" src="/images/lang_select/ChevronRight.svg" alt="Select English" />
              </div>
            </button>
            <button onClick={() => {
              i18n.changeLanguage('zh');
              navigate('/okuno-shima/renttutorial');
            }} className="language-button language-button-large" lang="zh">
              <span>簡体中文</span>
              <div className="arrow-circle">
                <img className="arrow-icon" src="/images/lang_select/ChevronRight.svg" alt="Select Simplified Chinese" />
              </div>
            </button>
            <button onClick={() => {
              i18n.changeLanguage('ko');
              navigate('/okuno-shima/renttutorial');
            }} className="language-button language-button-large" lang="ko">
              <span>한국어</span>
              <div className="arrow-circle">
                <img className="arrow-icon" src="/images/lang_select/ChevronRight.svg" alt="Select Korean" />
              </div>
            </button>
          </nav>
        </section>
      </div>
    </main>
  </div>
  );
};
